import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import AdminSidebar from "../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../component/AdminComp/AdminTopbar";
import { Card, Spinner } from "react-bootstrap";
import axios from "axios";
import { baseurl } from "../../Baseurl";
import { Eye, EyeOff, Trash2 } from "react-feather";
import Swal from "sweetalert2";

const CustomerDetail = () => {
  const { uniqueid } = useParams();
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showUniqueId, setShowUniqueId] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserDetail = async () => {
      try {
        const response = await axios.get(`${baseurl}getUserById/${uniqueid}`);
        setUserData(response.data.user);
      } catch (error) {
        console.error("Error fetching user detail:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserDetail();
  }, [uniqueid]);

  const handleDeleteAccount = async () => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "This will permanently delete the user account!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    });

    if (confirm.isConfirmed) {
      try {
        const response = await axios.delete(`${baseurl}deleteUserById/${userData.user_unique_id}`);
        if (response.data.status === "success") {
          Swal.fire("Deleted!", "The user account has been deleted.", "success");
          navigate(-1);
        } else {
          Swal.fire("Error", response.data.message || "Something went wrong.", "error");
        }
      } catch (error) {
        console.error("Delete error:", error);
        Swal.fire("Error", "Failed to delete account.", "error");
      }
    }
  };

  const renderUserTable = (user) => (
    <div className="card p-3">
      {[
        { label: "Unique ID", value: user.user_unique_id, mask: true },
        { label: "First Name", value: user.first_name },
        { label: "Middle Name", value: user.middle_name || '-' },
        { label: "Last Name", value: user.last_name },
        { label: "Email", value: user.user_email },
        { label: "Phone", value: user.phone },
        { label: "Country", value: user.country || '-' },
        { label: "Region", value: user.region || '-' },
        {
          label: "Created At",
          value: new Date(user.created_at).toLocaleString()
        }
      ].map(({ label, value, mask }, idx) => (
        <div key={idx} className="row mb-3 align-items-center">
          <label className="col-sm-3 col-form-label fw-bold text-dark">
            {label}
            {mask && (
              <span
                role="button"
                onClick={() => setShowUniqueId((prev) => !prev)}
                className="ms-2"
                style={{ cursor: "pointer" }}
              >
                {showUniqueId ? <EyeOff size={16} /> : <Eye size={16} />}
              </span>
            )}
          </label>
          <div className="col-sm-9">
            <input
              type="text"
              className="form-control"
              value={mask && !showUniqueId ? "••••••••••••" : value}
              readOnly
            />
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />
      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />
        <div className="container-fluid text-start">
          <h4 className="mb-3">Customer Details</h4>

          {loading ? (
            <div className="d-flex justify-content-center align-items-center" style={{ height: "200px" }}>
              <Spinner animation="border" />
            </div>
          ) : userData ? (
            <>
              <div className="row mb-4 g-2">
                <div className="col-md-8">
                  <Card className="shadow-sm p-3 mb-2 d-flex flex-row justify-content-between align-items-center">
                    <h5 className="mb-0">Customer Info</h5>
                    <button className="btn btn-danger" onClick={handleDeleteAccount}>
                      <Trash2 className="me-1" /> Delete Account
                    </button>
                  </Card>

                  <Card className="shadow-sm p-3 mb-2">
                    {renderUserTable(userData)}
                  </Card>
                </div>
              </div>
            </>
          ) : (
            <p>No user data found.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomerDetail;
